import {del, get, put} from './http';
import {type DeliveryAction} from './delivery-actions';

export type P0SlackAlertConfig = {
  pending_webhook_url: string | null;
  delivery_webhook_url: string | null;
  escalation_webhook_url: string | null;
  test_mode: boolean;
  test_simulated_status_code: number | null;
  test_mode_allowed: boolean;
  modified_by: string | null;
  modified_at: string | null;
};

export type UpdateP0SlackAlertConfigPayload = {
  pending_webhook_url: string | null;
  delivery_webhook_url: string | null;
  escalation_webhook_url: string | null;
  test_mode: boolean;
  test_simulated_status_code: number | null;
};

export const p0SlackAlertConfigApi = {
  get: async () => get<P0SlackAlertConfig>('/p0-slack-alert-config'),
  update: async (payload: UpdateP0SlackAlertConfigPayload) =>
    put<UpdateP0SlackAlertConfigPayload, P0SlackAlertConfig>('/p0-slack-alert-config', payload),
  deliveryActions: async () => get<DeliveryAction[]>('/p0-slack-alert-config/delivery-actions'),
  clearDeliveryActions: async () => del('/p0-slack-alert-config/delivery-actions')
};
